import Link from "components/shared/Link";
import Image from "components/shared/Image";

const mainClass = "syndicated-profile__card";

const Card = ({ username, avatar, content, extended }) => {
	return (
		<>
			{content?.header && (
				<p className={`${mainClass}__header`}>{content.header}</p>
			)}
			<Link
				{...content}
				className={`${mainClass}${extended ? ` ${mainClass}--extended` : ""}`}
			>
				{avatar && (
					<Image
						name="avatar"
						image={{
							url: avatar?.url,
							title: avatar?.title || content?.defaultAvatarTitle,
							height: 50,
							width: 50,
						}}
					/>
				)}
				<div
					className={`${mainClass}__details${
						avatar ? ` ${mainClass}__details--with-avatar` : ""
					}`}
				>
					<h3
						className={`${mainClass}__guest guestSensitive${
							extended ? ` ${mainClass}__guest--extended` : ""
						}`}
					>
						{username}
					</h3>
					{content?.title && (
						<h4 className={`${mainClass}__label`}>{content?.title}</h4>
					)}
				</div>
			</Link>
		</>
	);
};

export default Card;
